import { useState, useEffect } from "react";
import { Menu, X, Shield } from "lucide-react";

const NAV_ITEMS = [
    { id: "command-deck", label: "Command Deck" },
    { id: "sovereign-pace", label: "Sovereign Pace" },
    { id: "mos-crosswalk", label: "MOS Crosswalk" },
    { id: "benefits-vault", label: "Benefits Vault" },
    { id: "recruiter-shield", label: "Recruiter Shield" },
    { id: "transition-strike", label: "Transition Strike" },
];

export const Header = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTo = (id) => {
        setOpen(false);
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <header
            data-testid="vanguard-header"
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-200 ${
                scrolled ? "bg-black/95 backdrop-blur-sm" : "bg-black/70 backdrop-blur-sm"
            }`}
        >
            <div className="border-b border-zinc-800/80">
                <div className="max-w-[1600px] mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
                    <button
                        data-testid="vanguard-logo"
                        onClick={() => scrollTo("command-deck")}
                        className="flex items-center gap-3 group"
                    >
                        <div className="relative w-9 h-9 border border-gold-300 flex items-center justify-center bg-black">
                            <Shield className="w-4 h-4 text-gold-300 group-hover:text-gold-100 transition-colors" />
                            <span className="absolute -top-1 -left-1 w-2 h-2 border-t border-l border-gold-300" />
                            <span className="absolute -bottom-1 -right-1 w-2 h-2 border-b border-r border-gold-300" />
                        </div>
                        <div className="leading-none text-left">
                            <div className="font-black tracking-[0.18em] uppercase text-sm text-white">
                                Vanguard
                            </div>
                            <div className="label-tactical mt-0.5">Command · v1.0</div>
                        </div>
                    </button>

                    <nav className="hidden lg:flex items-center gap-1">
                        {NAV_ITEMS.map((item) => (
                            <button
                                key={item.id}
                                data-testid={`nav-${item.id}`}
                                onClick={() => scrollTo(item.id)}
                                className="px-3 py-2 text-xs uppercase tracking-[0.18em] font-bold text-zinc-400 hover:text-gold-300 transition-colors"
                            >
                                {item.label}
                            </button>
                        ))}
                    </nav>

                    <div className="hidden lg:flex items-center gap-3">
                        <div className="flex items-center gap-2 border border-zinc-800 px-3 py-1.5">
                            <span className="w-1.5 h-1.5 bg-emerald-400 animate-pulse" />
                            <span className="text-[10px] tracking-[0.2em] uppercase text-zinc-300 font-bold">
                                Operational
                            </span>
                        </div>
                    </div>

                    <button
                        data-testid="mobile-menu-toggle"
                        className="lg:hidden text-gold-300 p-2"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                    </button>
                </div>
            </div>
            {open && (
                <div className="lg:hidden border-b border-zinc-800 bg-black">
                    <div className="px-6 py-4 flex flex-col">
                        {NAV_ITEMS.map((item) => (
                            <button
                                key={item.id}
                                data-testid={`mobile-nav-${item.id}`}
                                onClick={() => scrollTo(item.id)}
                                className="text-left py-3 text-xs uppercase tracking-[0.18em] font-bold text-zinc-300 border-b border-zinc-900"
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
